import {
  Box,
  Center,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";

export default function BoardNavigation() {
  const { pathname } = useRouter();

  return (
    <Center w="200px" h="130px" bg="#E53E3E" className="parent">
      <Breadcrumb
        fontWeight="medium"
        fontSize="sm"
        mt="1"
        paddingBottom="4"
        className={"children"}
      >
        <BreadcrumbItem>
          <BreadcrumbLink href="#">Home</BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink href="#">고객센터</BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage color="#E53E3E" fontWeight="bold">
          <BreadcrumbLink href="#">
            {pathname === "/board/faq"
              ? "FAQ"
              : pathname === "/board/qna"
              ? "QnA"
              : pathname === "/board/review"
              ? "구매후기"
              : pathname === "/board/notice"
              ? "공지사항"
              : pathname === "/policy/service"
              ? "이용약관"
              : pathname === "/policy/privacy"
              ? "개인정보취급방침"
              : null}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Heading as="h4" size="md" color="white" letterSpacing="-1px">
        고객센터
      </Heading>
      <Box className="layout-category flex-center center-nav">
        <Box className="layout__category-box">
          <Link href="/board/faq" passHref>
            <span
              className={[
                "cursor",
                pathname === "/board/faq" ? "clicked" : null,
              ].join(" ")}
            >
              FAQ
            </span>
          </Link>
          <Link href="/board/qna" passHref>
            <span
              className={[
                "cursor",
                pathname === "/board/qna" ? "clicked" : null,
              ].join(" ")}
            >
              {" "}
              QnA
            </span>
          </Link>
          <Link href="/board/review" passHref>
            <span
              className={[
                "cursor",
                pathname === "/board/review" ? "clicked" : null,
              ].join(" ")}
            >
              구매후기
            </span>
          </Link>
          <Link href="/board/notice" passHref>
            <span
              className={[
                "cursor",
                pathname === "/board/notice" ? "clicked" : null,
              ].join(" ")}
            >
              공지사항
            </span>
          </Link>
          <Link href="/policy/service" passHref>
            <span
              className={[
                "cursor",
                pathname === "/policy/service" ? "clicked" : null,
              ].join(" ")}
            >
              이용약관
            </span>
          </Link>
          <Link href="/policy/privacy" passHref>
            <span
              className={[
                "cursor",
                pathname === "/policy/privacy" ? "clicked" : null,
              ].join(" ")}
            >
              개인정보취급방침
            </span>
          </Link>
        </Box>
      </Box>
    </Center>
  );
}
